<template>
	<section class="main-content contentblocks">
		<div class="row row-header align-center white">
			<div v-if="contentBlocksContent.length">
				<div class="pre-header-logo" />
				<h2 class="subtitle">
					{{ contentBlocksSubtitle }}
				</h2>
				<div v-parse-links v-html="contentBlocksContent" />
			</div>
		</div>
		<div v-for="(block, index) in contentblocks" :key="block.ID" class="row contentblock">
			<div class="columns column6 contentblock-content" :class="index % 2 === 0 ? 'right' : 'left'">
				<h3>{{ block.header }}</h3>
				<div v-parse-links v-html="block.content" />
			</div>
			<div class="contentblock-image">
				<picture>
					<source v-if="block.imageWebp" :srcset="block.imageWebp" type="image/webp" />
					<source :srcset="block.image" />
					<img loading="lazy" :src="block.image" :alt="block.imageAlt" />
				</picture>
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	contentblocks: { type: Array, default: () => [] },
	contentBlocksContent: { type: String, default: '' },
	contentBlocksSubtitle: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.contentblocks {
	background: var(--contentblock-background-color);
}

.contentblock {
	margin: 80px auto;
	position: relative;
	display: flex;
	flex-flow: row nowrap;
	justify-content: space-between;
	align-items: center;
	gap: 100px;

	&:nth-child(even) {
		flex-flow: row-reverse nowrap;
	}
}

.row-header {
	max-width: 1000px;
}

.contentblock-image {
	width: 78%;
	z-index: 1;

	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
}

.contentblock-content {
	padding: 0 40px;
	margin: 0 auto;
	position: relative;
	z-index: 2;
}

@media (max-width: 1280px) {
	.contentblock {
		gap: 30px;
		padding: 0 20px;
	}

	.contentblock-image {
		width: 55%;
	}

	.contentblock-content {
		padding: 0 20px;
	}
}

@media (max-width: 920px) {
	.contentblock-image {
		width: 100%;
		position: relative;
		inset: auto;
	}

	.contentblock {
		display: flex;
		flex-flow: wrap column-reverse !important;
		margin: 0 auto;
	}

	.contentblock-content {
		margin: 0 auto;
		padding: 30px 0;
	}
}
</style>
